import { useState } from "react"
import { SelectOption } from "../../../../services/dashboardService"

const useAbsenceContact = () => {
  const [contactMadeBy, setContactMadeBy] = useState<SelectOption>()
  const [contactDateTime, setContactDateTime] = useState<Date | null>(null)

  return {
    contactMadeBy,
    setContactMadeBy,
    contactDateTime,
    setContactDateTime,
  }
}

export default useAbsenceContact